import { Badge, Group, Text } from "@mantine/core";
import { ReactNode } from "react";

export const PropertyBadge = (props: { title: string; children: ReactNode }) => (
    <Group gap={0} wrap="nowrap">
        <Badge
            variant="default"
            style={{
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                marginRight: "-1px",
            }}
        >
            {props.title}
        </Badge>
        <Badge color={"transparent"} styles={{ root: { paddingLeft: 0 } }} style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}>
            <Text size="xs" fw="bold">
                {props.children}
            </Text>
        </Badge>
    </Group>
);
